// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__38mrW","errorLogs":"EditorFooter_errorLogs__3Rrcq"};